import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'small' | 'large';
}

export default function MovieCard({ movie, size = 'small' }: MovieCardProps) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-200 ${
        size === 'large' ? 'aspect-[16/9]' : 'aspect-[3/4]'
      }`}>
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - ${movie.category}高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-3">
            <p className="text-xs text-foreground-300 line-clamp-2">{movie.description}</p>
            <div className="flex items-center gap-2 mt-2">
              <span className="text-xs text-primary-400 bg-primary-500/20 px-2 py-0.5 rounded whitespace-nowrap">{movie.category}</span>
              <span className="text-xs text-foreground-400">{movie.duration}</span>
            </div>
          </div>
        </div>

        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {movie.isHot && (
            <span className="bg-accent-500 text-background-950 text-xs font-semibold px-2 py-0.5 rounded whitespace-nowrap">热播</span>
          )}
          {movie.isNew && (
            <span className="bg-primary-500 text-background-950 text-xs font-semibold px-2 py-0.5 rounded whitespace-nowrap">上新</span>
          )}
        </div>

        <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm text-primary-400 text-xs font-semibold px-2 py-0.5 rounded whitespace-nowrap">
          <i className="ri-star-fill text-[10px] mr-0.5"></i>
          {movie.rating}
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
          {movie.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">
          {movie.cast.slice(0, 2).join(' / ')}
        </p>
      </div>
    </Link>
  );
}